import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { portalApi, setPortalToken } from "@/lib/portalApi";

const PortalAuthCtx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await portalApi.get("/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await portalApi.post("/auth/login", { email, password });
    if (data?.access_token) setPortalToken(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const setPassword = useCallback(async (token, password) => {
    const { data } = await portalApi.post("/auth/set-password", { token, password });
    if (data?.access_token) setPortalToken(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await portalApi.post("/auth/logout"); } catch { /* ignore */ }
    setPortalToken(null);
    setUser(null);
  }, []);

  return (
    <PortalAuthCtx.Provider value={{ user, loading, login, setPassword, logout, refresh }}>
      {children}
    </PortalAuthCtx.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthCtx);
  if (!ctx) throw new Error("usePortalAuth must be inside PortalAuthProvider");
  return ctx;
}
